import { CommonEnums } from "../../enums/common.enums";
import { EnvVariables } from "../../enums/env.variables.enums";
import { LocalStorageHelpers } from "./localstorage.helpers";

export let getImageUrl = (imageUrl: string) => {
  let baseURL = EnvVariables.apiEndpoint;
  let imageUrlFix;
  if (imageUrl) {
    imageUrlFix = `${baseURL}/${imageUrl}`;
  } else {
    imageUrlFix = "";
  }

  return imageUrlFix;
};

export const getAgentMediumImage = (uploadRecord: any) => {
  if (!uploadRecord) return "";

  if (uploadRecord.medium_image_url) {
    return getCdnImageUrl(uploadRecord.medium_image_url);
  }

  if (uploadRecord.small_image_url) {
    return getCdnImageUrl(uploadRecord.small_image_url);
  }

  if (uploadRecord.storage_key) {
    return getCdnImageUrl(uploadRecord.storage_key);
  }

  if (uploadRecord.compressed_file_path) {
    return getImageUrl(uploadRecord.compressed_file_path);
  }

  if (uploadRecord.original_file_path) {
    return getImageUrl(uploadRecord.original_file_path);
  }

  return "";
};

export const getAgentProfileImageUrl = (uploadRecord: any) => {
  if (!uploadRecord) return "";

  if (uploadRecord.medium_image_url) {
    return getCdnImageUrl(uploadRecord.medium_image_url);
  }
  if (uploadRecord.small_image_url) {
    return getCdnImageUrl(uploadRecord.small_image_url);
  }
  if (uploadRecord.storage_key) {
    return getCdnImageUrl(uploadRecord.storage_key);
  }
  if (uploadRecord.compressed_file_path) {
    return getImageUrl(uploadRecord.compressed_file_path);
  }
  if (uploadRecord.original_file_path) {
    return getImageUrl(uploadRecord.original_file_path);
  }
  return "";
};

export const getAgentLargeImage = (uploadRecord: any) => {
  if (!uploadRecord) return "";

  if (uploadRecord.large_image_url) {
    return getCdnImageUrl(uploadRecord.large_image_url);
  }

  if (uploadRecord.medium_image_url) {
    return getCdnImageUrl(uploadRecord.medium_image_url);
  }

  if (uploadRecord.storage_key) {
    return getCdnImageUrl(uploadRecord.storage_key);
  }

  if (uploadRecord.original_file_path) {
    return getImageUrl(uploadRecord.original_file_path);
  }

  return "";
};

export const getCdnImageUrl = (storageKey?: string) => {
  if (!storageKey) return "";

  const baseURL = EnvVariables.cdnBaseUrl;

  if (!baseURL) return storageKey;

  return `${baseURL}/${storageKey}`;
};

export const resolvePropertyVariantImageUrl = (
  variantKey?: string,
  fallbackPath?: string,
) => {
  if (variantKey) {
    return getCdnImageUrl(variantKey);
  }

  if (fallbackPath) {
    return getImageUrl(fallbackPath);
  }

  return "";
};

export const getPropertyVariantKey = (
  imageObj: any,
  variant: "medium" | "large" | "extra_large" | "original" = "medium",
) => {
  if (!imageObj) return "";

  switch (variant) {
    case "medium":
      return imageObj?.medium_image_url || "";
    case "large":
      return imageObj?.large_image_url || "";
    case "extra_large":
      return imageObj?.extra_large_image_url || "";
    case "original":
      return imageObj?.original_image_url || imageObj?.storage_key || "";
    default:
      return imageObj?.medium_image_url || "";
  }
};

export const resolvePropertyVariantFromObject = (
  imageObj: any,
  variant: "medium" | "large" | "extra_large" | "original" = "medium",
  fallbackPath?: string,
) => {
  const variantKey = getPropertyVariantKey(imageObj, variant);

  if (variantKey) {
    return getCdnImageUrl(variantKey);
  }

  if (fallbackPath) {
    return getImageUrl(fallbackPath);
  }

  return "";
};

export let getInvitationCode = () => {
  let userData: any =
    LocalStorageHelpers?.getAgencyData() ||
    LocalStorageHelpers?.getAgentData() ||
    LocalStorageHelpers?.getUserData();
  let baseURL = EnvVariables.appEndpoint;
  let invitation_code = userData?.invitation_code;
  let invitationCodeUrl = `${baseURL}/register?invitation_code=${invitation_code}`;

  return invitationCodeUrl;
};
export let getAddress = ({
  unit,
  no,
  streetName,
  city,
  state,
  country,
  postCode,
}: {
  unit?: string;
  no: string;
  streetName: string;
  city: string;
  state: string;
  country: string;
  postCode: string;
}) => {
  let address = `${streetName}, ${city}, ${state}, ${postCode}`;

  const unitStr = unit ? unit.toString().trim() : "";
  const numberStr = no ? no.toString().trim() : "";

  if (unitStr && numberStr) {
    address = `${unitStr}/${numberStr} ${address}`;
  } else if (numberStr) {
    address = `${numberStr} ${address}`;
  } else if (unitStr) {
    address = `${unitStr} ${address}`;
  }

  return address;
};

export let getAgentName = () => {
  let userData: any =
    LocalStorageHelpers?.getAgentData() || LocalStorageHelpers?.getAgencyData();

  let agentName = "";

  if (userData?.role === CommonEnums?.userRole?.agent) {
    agentName = `${userData?.principal_agent_first_name} ${userData?.principal_agent_last_name}`;
  } else {
    agentName = `${userData?.principal_agent_id?.principal_agent_first_name} ${userData?.principal_agent_id?.principal_agent_last_name}`;
  }

  return agentName;
};

export let getAgentProfileImg = () => {
  let userData: any =
    LocalStorageHelpers?.getAgentData() || LocalStorageHelpers?.getAgencyData();

  let agentImg = "";

  if (userData?.role === CommonEnums?.userRole?.agent) {
    agentImg = `${userData?.profile_image}`;
  } else {
    agentImg = `${userData?.principal_agent_id?.profile_image_ref?.compressed_file_path}`;
  }
  return getImageUrl(agentImg);
};

export let getAgentId = () => {
  let userData: any =
    LocalStorageHelpers?.getAgentData() || LocalStorageHelpers?.getAgencyData();

  let agentId = "";

  if (userData?.role === CommonEnums?.userRole?.agent) {
    agentId = userData?._id;
  } else {
    agentId = userData?.principal_agent_id?._id;
  }

  return agentId;
};

export let getUserId = () => {
  let userData: any = LocalStorageHelpers?.getUserData();
  let userId = userData?._id;

  return userId;
};

export let getAgencyId = () => {
  let userData: any =
    LocalStorageHelpers?.getAgentData() || LocalStorageHelpers?.getAgencyData();

  let agencyId = "";

  if (userData?.role === CommonEnums?.userRole?.agent) {
    agencyId = userData?.agency_ref?._id;
  } else {
    agencyId = userData?._id;
  }

  return agencyId;
};

export let getStatus = (status: string) => {
  let typeString = "";

  switch (status) {
    case CommonEnums?.userStatus?.active:
      typeString = CommonEnums?.userStatus?.active;
      break;
    case CommonEnums?.userStatus?.disabled:
      typeString = CommonEnums?.userStatus?.disabled;
      break;
    case CommonEnums?.userStatus?.deactivated:
      typeString = CommonEnums?.userStatus?.deactivated;
      break;
    case CommonEnums?.userStatus?.draft:
      typeString = CommonEnums?.userStatus?.draft;
      break;
    case CommonEnums?.userStatus?.trash:
      typeString = CommonEnums?.userStatus?.trash;
      break;

    case CommonEnums?.userStatus?.trash:
      typeString = CommonEnums?.userStatus?.trash;
      break;

    case CommonEnums?.userStatus?.published:
      typeString = CommonEnums?.userStatus?.published;
      break;

    case CommonEnums?.userStatus?.unpublished:
      typeString = CommonEnums?.userStatus?.unpublished;
      break;

      case CommonEnums?.status?.pending_for_admin_approval:
      typeString = "Pending for Admin Approval";
      break;
    case CommonEnums?.status?.rejected_by_admin:
      typeString = "Rejected by Admin";
      break;
    case CommonEnums?.status?.blocked_by_admin:
      typeString = "Blocked by Admin";
      break;
  }

  return typeString;
};

export let getSubType = (type: string) => {
  let typeString = "";

  switch (type) {
    case CommonEnums.subscriptionType?.property_marketing?.key:
      typeString = CommonEnums.subscriptionType.property_marketing.value;
      break;
    case CommonEnums.subscriptionType.agent_marketing.key:
      typeString = CommonEnums.subscriptionType.agent_marketing.value;
      break;
  }

  return typeString;
};

export let getPriceType = (type: string) => {
  let typeString = "";

  switch (type) {
    case CommonEnums.priceType.per_property.key:
      typeString = CommonEnums.priceType.per_property.value;
      break;
    case CommonEnums.priceType.per_month.key:
      typeString = CommonEnums.priceType.per_month.value;
      break;
  }

  return typeString;
};

export const getRegistrationStatus = (status: string) => {
  let statusTag = "";

  switch (status) {
    case CommonEnums.inviteStatus?.pending_for_profile_completion?.key:
      statusTag =
        CommonEnums.inviteStatus?.pending_for_profile_completion?.value;
      break;
    case CommonEnums.inviteStatus.pending_for_subscription?.key:
      statusTag = CommonEnums.inviteStatus.pending_for_subscription?.value;
      break;
    case CommonEnums.inviteStatus.pending_for_registration?.key:
      statusTag = CommonEnums.inviteStatus.pending_for_registration?.value;
      break;

    case CommonEnums.inviteStatus.completed?.key:
      statusTag = CommonEnums.inviteStatus.completed?.value;
      break;

    case CommonEnums.inviteStatus.completing_agency_profile?.key:
      statusTag = CommonEnums.inviteStatus.completing_agency_profile?.value;
      break;

    case CommonEnums.inviteStatus.waiting_for_registration_approval?.key:
      statusTag =
        CommonEnums.inviteStatus.waiting_for_registration_approval?.value;
      break;

    case CommonEnums.inviteStatus.pending_for_agency_info?.key:
      statusTag = CommonEnums.inviteStatus.pending_for_agency_info?.value;
      break;

    case CommonEnums.inviteStatus.verified_phone?.key:
      statusTag = CommonEnums.inviteStatus.verified_phone?.value;
      break;

    case CommonEnums.inviteStatus.phone_verification_is_pending?.key:
      statusTag = CommonEnums.inviteStatus.phone_verification_is_pending?.value;
      break;
    case CommonEnums.inviteStatus.pending?.key:
      statusTag = CommonEnums.inviteStatus.pending?.value;
      break;

    case CommonEnums.inviteStatus.profile_completion_pending?.key:
      statusTag = CommonEnums.inviteStatus.profile_completion_pending?.value;
      break;

    case CommonEnums.inviteStatus.pending_for_agency_registration?.key:
      statusTag =
        CommonEnums.inviteStatus.pending_for_agency_registration?.value;
      break;
    case CommonEnums.inviteStatus.agency_registration_completed?.key:
      statusTag = CommonEnums.inviteStatus.agency_registration_completed?.value;
      break;
    case CommonEnums.inviteStatus.completed_agent_info?.key:
      statusTag = CommonEnums.inviteStatus.completed_agent_info?.value;
      break;
    case CommonEnums.inviteStatus.pending_for_agent_info?.key:
      statusTag = CommonEnums.inviteStatus.pending_for_agent_info?.value;
      break;
  }

  return statusTag;
};

export const rootCssSet = () => {
  let root = document.getElementById("root");

  if (root?.classList.contains("root-overflow-hidden")) {
    root?.classList.remove("root-overflow-hidden");
  } else {
    root?.classList.add("root-overflow-hidden");
  }
};

export const getPostType = (post: string) => {
  let postType = "";

  switch (post) {
    case CommonEnums.postType?.image_post?.key:
      postType = CommonEnums.postType?.image_post?.value;
      break;
    case CommonEnums.postType?.reel_post?.key:
      postType = CommonEnums.postType?.reel_post?.value;
      break;
    case CommonEnums.postType?.story_post?.key:
      postType = CommonEnums.postType?.story_post?.value;
      break;

    case CommonEnums.postType?.video_post?.key:
      postType = CommonEnums.postType?.video_post?.value;
      break;
  }

  return postType;
};

export const onlyNumRegex = (value: any) => {
  const regex = /^\d*$/;
  let check = regex.test(value);
  return check;
};

export const onlyNumAndDecimalRegex = (value: any) => {
  const regex = /^[0-9]*\.?[0-9]*$/;
  let check = regex.test(value);
  return check;
};
